<template>
  <div class="pricingTable" >
    <div class="pricingTable_row" >
      <span>{{ booking.name }} {{ $showTax ? '(incl. tax)' : ''}}</span>
      <span>{{ paymentAmount | currency( booking.currency ) }}</span>
    </div>
    <div v-if="cardSurcharge" class="pricingTable_row surcharge_row" >
      <span>Card surcharge</span>
      <span>{{ cardSurcharge | currency( booking.currency ) }}</span>
    </div>
    <div class="pricingTable_row pricingTable_totals">
      <span>Your total</span>
      <span>{{ totalPaymentAmount | currency( booking.currency ) }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    booking: {
      required: true,
      type: Object
    },
    paymentAmount: {
      required: true,
      type: Number
    },
    cardSurcharge: {
      default: 0,
      type: Number
    }
  },
  computed: {
    totalPaymentAmount () {
      return this.paymentAmount + this.cardSurcharge
    }
  }
}
</script>
